@if (isInitialized) {
    <div class="ws-flex-container-vertical ws-flex-auto">
        <ws-bread-crumbs [breadcrumbs]="breadcrumbs" currentPageTitle="Data Imports"></ws-bread-crumbs>
        <div class="ws-section">
            <div class="ws-section__header">
                <h4 class="ws-section__header__title page-title">
                    Data Imports
                    <ag-grid-row-count [gridApi]="gridApi" [gridOptions]="gridOptions"></ag-grid-row-count>
                </h4>
                <div class="ws-section__header__actions">
                    <div class="ws-section__header__actions__item">
                        <button type="button"
                                class="ace-btn btn-link"
                                (click)="navigateToImportSpecifications()"
                                helpTooltip
                                [helpContentId]="dataImportSpecificationsHelpContentId"
                                position="bottom">
                            Data Import Specifications
                        </button>
                    </div>
                    @if (canEdit) {
                        <div class="ws-section__header__actions__item">
                            <begin-new-import #newImport buttonSize="small"
                                              [companyId]="companyId"
                                              (refresh)="refresh()">
                            </begin-new-import>
                        </div>
                    }
                    <div class="ws-section__header__actions__item">
                        <button type="button"
                                class="ace-btn btn-sm btn-secondary has-icon"
                                (click)="refresh()"
                                [disabled]="refreshing"
                                helpTooltip
                                helpContentId="app.refresh"
                                position="bottom">
                            <i class="fa fa-refresh"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="ws-flex-container-vertical ws-flex-auto">
            <div class="ws-flex-container-horizontal filter-row">
                <div class="ws-flex-container-horizontal filter-group ws-flex-align-items-center">
                    <label class="ws-flex-none small ws-font-weight-normal"
                           helpTooltip
                           helpContentId="import-list.completed"
                           position="bottom">
                        <input type="checkbox" [(ngModel)]="includeCompleted" (change)="onIncludeCompletedChange()">
                        Include Completed
                    </label>
                </div>
            </div>
            <ws-ag-grid-angular [gridOptions]="gridOptions"
                                (gridReady)="onAgGridReady($event)"
                                [companyId]="companyId"
                                [gridId]="gridId">
            </ws-ag-grid-angular>
        </div>
    </div>
}
